// Registers vendored widgets at import time. Apps just `import "@viz/widgets"`
// and the registry is populated.
//
// This is a stripped-down vendor of the viz-engine widgets package: the heavy
// renderer-backed widgets (graph, scene-3d, map, pdf) are intentionally NOT
// included so the canvas does not need to ship @viz/renderer-* or pdfjs-dist.

import { registerWidget } from "@viz/presentation";
import Header from "./header.js";
import KpiRow from "./kpi-row.js";
import PropertyGrid from "./property-grid.js";
import EntityTable from "./entity-table.js";
import Tree from "./tree.js";
import Markdown from "./markdown.js";
import Container from "./container.js";
import Tabs from "./tabs.js";
import Split from "./split.js";
import Code from "./code.js";
import IFrame from "./iframe.js";
import Chart from "./chart.js";
import Timeline from "./timeline.js";

registerWidget("header", Header);
registerWidget("kpi-row", KpiRow);
registerWidget("property-grid", PropertyGrid);
registerWidget("entity-table", EntityTable);
registerWidget("tree", Tree);
registerWidget("markdown", Markdown);
registerWidget("container", Container);
registerWidget("tabs", Tabs);
registerWidget("split", Split);
registerWidget("code", Code);
registerWidget("iframe", IFrame);
registerWidget("chart", Chart);
registerWidget("timeline", Timeline);

export {
  Header, KpiRow, PropertyGrid, EntityTable, Tree, Markdown, Container, Tabs, Split, Code,
  IFrame, Chart, Timeline,
};
